import { useNavigate } from '@tanstack/react-router';
import { useModal } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import { ChestPromptModal } from '~/components/ChestPromptModal/ChestPromptModal';

export function ChestNotPlayedModal() {
  const { t } = useTranslation('modals');
  const { closeModal } = useModal();
  const navigate = useNavigate();
  const description = t('chestNotPlayed.description');

  return (
    <ChestPromptModal
      ctaLabel={t('chestNotPlayed.cta')}
      description={description}
      heading={t('chestNotPlayed.heading')}
      onCta={() => {
        closeModal();
        void navigate({ to: '/games' });
      }}
      testId="chest-modal-not-played"
      title={t('chestNotPlayed.title')}
    />
  );
}
